import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

function ViewAttendance() {
    const { branchId } = useParams(); // Extract mobile number and branch from URL
    // console.log("branchId", branchId);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const location = useLocation(); // Get the location object
    const path = location.pathname;
const empmobile = path.split('/')[2];
    const queryParams = new URLSearchParams(location.search);
    const employeeNameFromQuery = queryParams.get('employeeName');
    const [employeeName, setEmployeeName] = useState(employeeNameFromQuery || ''); 
    const [attendanceDate, setAttendanceDate] = useState(new Date().toISOString().substring(0, 7)); 
    const adminmob = localStorage.getItem('adminmob');
    const [dates, setDates] = useState({ dateArray: [], firstDay: 0 }); 
    const [PresentCountValue, setPresentCountValue] = useState(0);
    const [absentCountValue, setAbsentCountValue] = useState(0);
    const [halfdayCountValue, setHalfDayCountValue] = useState(0);
    const [weekoffCountValue , setWeekOffCountValue] = useState(0);
    const [attendanceData, setAttendanceData] = useState([]);
    const [halfDayDates, setHalfDayDates] = useState([]); 
    const [weekOffData, setWeekOffData] = useState({});
    const udiseNumber= localStorage.getItem("udiseNumber")
    const today = new Date(); // Get today's date
    const todayString = today.toISOString().substring(0, 10); // Format as YYYY-MM-DD
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  

    
const [weekOffDaysCount, setWeekOffDaysCount] = useState(0);

      useEffect(() => {
            const storedLanguage = localStorage.getItem('language') || 'English';
            setLanguage(storedLanguage);
          }, []);

    useEffect(() => {
        const fetchEmployeeData = async () => {
            const empurl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
            console.log("Fetching from:", empurl); // Log the URL being fetched
            console.log("adminmob:", adminmob); // Log adminmob
            console.log("empmobile:", empmobile); // Log empmobile
    
            try {
                const response = await fetch(empurl);
                if (response.ok) {
                    const data = await response.json();
                    console.log("Fetched Employee Data:", data); // Log the fetched data
                    console.log("setEmployeeName",data.Name);
                    
                    if (data && data.Name) {
                        setEmployeeName(data.Name); // Set employee name
                    } else {
                        console.error("Employee data is null or does not contain Name");
                    }
                } else {
                    console.error("Failed to fetch employee data:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching employee data:", error);
            }
        };
    
        fetchEmployeeData();
    }, [empmobile, branchId]);

    useEffect(() => {
        const updateAttendanceData = async () => {
            const attendanceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Attendance.json`;
            console.log("Fetching from:", attendanceUrl);
 
            try {
                const attendanceResponse = await fetch(attendanceUrl);
                if (attendanceResponse.ok) {
                    const data = await attendanceResponse.json();
                    console.log("Fetched Attendance Data:", data);
                    if (data && Object.keys(data).length > 0) {
                        setAttendanceData(data);
                    } else {
                        console.log("No attendance records found or data is null");
                    }
                } else {
                    console.error("Failed to fetch attendance data:", attendanceResponse.statusText);
                }
            } catch (error) {
                console.error("Error fetching attendance data:", error);
            } finally {
                setLoading(false);  // Set loading to false once data is fetched
            }
        };
 
        updateAttendanceData();
    }, [attendanceDate, empmobile, adminmob, branchId]);


useEffect(() => {
  setWeekOffDaysCount(0); 
  const fetchWeekOffData = async () => {
    const weekOffUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/PunchTimings.json`;
    console.log("weekOffUrl", weekOffUrl);

    try {
      const response = await fetch(weekOffUrl);
      if (response.ok) {
        const data = await response.json();
        setWeekOffData(data); // Set the fetched week off data

        const [year, month] = attendanceDate.split('-');
        let weekOffDaysUntilToday = 0; 
        const daysInMonth = new Date(year, month, 0).getDate();

        Object.keys(data).forEach((key) => {
          if (data[key] === "All undefineds Week Off") {
            for (let i = 1; i <= daysInMonth; i++) {
              const date = new Date(year, month - 1, i);
              const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });

              if (dayOfWeek === key && date <= today) {
                weekOffDaysUntilToday++;
              }
            }
          }
        });
        
        let weekOffCount = 0;
        Object.keys(data).forEach((key) => {
          if (data[key] === "All undefineds Week Off") {
            const daysInMonth = new Date(year, month, 0).getDate();
            for (let i = 1; i <= daysInMonth; i++) {
              const date = new Date(year, month - 1, i);
              const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });

              if (dayOfWeek === key) {
                weekOffCount++;
              }
            }
          }
        });

        setWeekOffCountValue(weekOffCount);


        setWeekOffDaysCount(weekOffDaysUntilToday); 
        console.log("Week Off Days Until Today:", weekOffDaysUntilToday);
      } else {
        console.error("Failed to fetch week off data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching week off data:", error);
    }
  };

  fetchWeekOffData();
}, [udiseNumber, attendanceDate, empmobile]); 

useEffect(() => {
  const fetchAttendanceDataForMonth = async () => {
    const attendanceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Attendance.json`;
console.log("weekoffCountValue",weekoffCountValue);
console.log("weekOffDaysCount",weekOffDaysCount);

    try {
      const attendanceResponse = await fetch(attendanceUrl);
      if (attendanceResponse.ok) {
        const attendanceData = await attendanceResponse.json();
        if (attendanceData) {
          let presentCount = 0;
          let halfDayCount = 0;
          let totalDays = 0;
          // Get the selected month and year
          const [year, month] = attendanceDate.split('-');

          // Calculate total number of days in the selected month
          const daysInMonth = new Date(year, month, 0).getDate();
          totalDays = daysInMonth;

          // Loop through attendance records
          for (const [date, details] of Object.entries(attendanceData)) {
            if (details && details.status) {
              const recordDate = new Date(date);
              const recordYear = recordDate.getFullYear();
              const recordMonth = recordDate.getMonth() + 1;

              if (recordYear === parseInt(year) && recordMonth === parseInt(month)) {
                if (details.status === "Full") {
                  presentCount++;
                } else if (details.status === "Half") {
                  halfDayCount++;
                }
              }
            }
          }

          // Calculate absent count
          const currentDate = new Date().getDate();
          let remainingDays = 0;

          const formattedMonth = String(month).padStart(2, '0');
          const formattedCurrentMonth = String(new Date().getMonth() + 1).padStart(2, '0');

          if (formattedMonth === formattedCurrentMonth) {
            remainingDays = currentDate - weekOffDaysCount - presentCount - halfDayCount;
          } else {
            remainingDays = totalDays - weekOffDaysCount - presentCount - halfDayCount; // Use weekOffDaysCount here too
          }

          console.log(
            "totalDays",
            totalDays,
            " ,",
            "currentDate",
            currentDate,
            " , ",
            "remainingDays",
            remainingDays,
            ", ",
            "presentCount",
            presentCount,
            ", ",
            "halfDayCount",
            halfDayCount,
            "  , ",
            "weekoffCountValue",
            weekoffCountValue,
            " , ",
            "weekOffDaysCount",
            weekOffDaysCount
          );

          let absentCount = 0;
          let absentDates = [];
          let weekOffDates = [];

          const today = new Date();
          const todayDate = today.getDate();
          const todayMonth = today.getMonth() + 1;
          const todayYear = today.getFullYear();

          if (formattedMonth === formattedCurrentMonth) {
            absentCount = todayDate - weekOffDaysCount - presentCount - halfDayCount;
            for (let i = 1; i <= todayDate; i++) {
              const date = new Date(year, month - 1, i);
              const formattedDate = `${year}-${month}-${String(i).padStart(2, '0')}`;
              if (!attendanceData[formattedDate] || attendanceData[formattedDate].status !== "Full" && attendanceData[formattedDate].status !== "Half") {
                const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
                if (weekOffData && weekOffData[dayOfWeek] === 'All undefineds Week Off' && date <= today) {
                  weekOffDates.push(formattedDate);
                } else {
                  absentDates.push(formattedDate);
                }
              }
            }
          } else {
            absentCount = totalDays - presentCount - halfDayCount - weekOffDaysCount; 
            for (let i = 1; i <= totalDays; i++) {
              const date = new Date(year, month - 1, i);
              const formattedDate = `${year}-${month}-${String(i).padStart(2, '0')}`;
              if (!attendanceData[formattedDate] || attendanceData[formattedDate].status !== "Full" && attendanceData[formattedDate].status !== "Half") {
                absentDates.push(formattedDate);
              }
              const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
              if (weekOffData && weekOffData[dayOfWeek] === 'All undefineds Week Off') {
                weekOffDates.push(formattedDate);
              }
            }
          }

          console.log("Absent Dates:", absentDates);
          console.log("Week Off Dates:", weekOffDates);

          setPresentCountValue(presentCount);
          setHalfDayCountValue(halfDayCount);
          setAbsentCountValue(absentCount);
        } else {
          console.log("No attendance records found or data is null");
        }
      } else {
        console.error("Failed to fetch attendance data:", attendanceResponse.statusText);
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  fetchAttendanceDataForMonth();
}, [ weekOffDaysCount]); 
useEffect(() => {
    setHalfDayDates([]);
    setHalfDayCountValue(0);
}, [attendanceDate]);



useEffect(() => {
    const generateDates = () => {
        if (attendanceDate && attendanceDate.includes('-')) {
            const [year, month] = attendanceDate.split('-');
            const daysInMonth = new Date(year, month, 0).getDate();
            const firstDay = new Date(year, month - 1, 1).getDay();
            const dateArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
            setDates({ dateArray, firstDay });
        } else {
            setDates({ dateArray: [], firstDay: 0 });
        }
    };

    generateDates();
}, [attendanceDate, weekOffData]);

    const handleDateClick = (date) => {
        const year = attendanceDate.split('-')[0];
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = attendanceDate.split('-')[1];
    const formattedDate = `${year}-${month}-${String(date).padStart(2, '0')}`;
        navigate(`/EditAttendance/${udiseNumber}?empmobile=${empmobile}&date=${formattedDate}&employeeName=${employeeName}`);
    }

    const handleClose = () => {
        navigate(-1); 
    };

    return (
            <div className="main-content-of-page" style={{marginBottom:'50px'}}>
            <div className="attendance-container" style={{border:'2px solid black'}}>
            <button style={{ 
                            backgroundColor: '#dc3545', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: '5px', 
                            cursor: 'pointer', 
                            fontSize: '20px', 
                            marginTop: '5px', 
                            marginLeft: '720px' ,
                            fontWeight:'bold',
                        }} onClick={handleClose}> 
                            X 
                        </button>
                        <h1 className="attendance-header" style={{fontSize:'20px'}}>{employeeName || 'Employee Name'}</h1>
                        <Link to={`/Profile?empmobile=${empmobile}&employeeName=${employeeName}`}>
                        </Link>
                        <button 
    className="profile-button" 
    onClick={() => navigate(`/Profile?empmobile=${empmobile}&employeeName=${employeeName}`)} // Pass parameters
    style={{ marginLeft: '650px', padding: '5px 10px', cursor: 'pointer',border:'1px solid black',borderRadius:'6px',backgroundColor:'#03365e',color:'white' }}
>
    <i class="fa-solid fa-user" style={{ marginRight: '5px' }}></i>{language === "English" ? "Profile" : "प्रोफाइल"}</button>
            
            <div className="attendance-section">
                    <label htmlFor="attendance" style={{fontSize:'18px'}}>{language === "English" ? "Attendance For:" : "उपस्थिती :"}</label>
                    <input 
                        type="month" 
                        id="attendance" 
                        name="attendance" 
                        value={attendanceDate} 
                        onChange={(e) => setAttendanceDate(e.target.value)
                        } 
                        style={{border:"2px solid black",borderRadius:'6px'}}
                    />
                </div>
                <div className="attendance-labels">
                    <div>
                        <label>{language === "English" ? "Present" : "उपस्थित"}</label>
                        <div>{PresentCountValue}</div>
                    </div>

                    <div className="vertical-line"></div>
                    <div>
                        <label>{language === "English" ? "Absent" : "अनुपस्थित"}</label>
                        <div>{absentCountValue}</div>
                    </div>

                    <div className="vertical-line"></div>
                    <div>
                    <label>{language === "English" ? "Half Day" : "अर्धा दिवस"}</label>
                    <div>{halfdayCountValue}</div>
                    </div>


                    <div className="vertical-line"></div>
                    <label>{language === "English" ? "Paid Leave" : "सशुल्क रजा"} </label>

                    <div className="vertical-line"></div>
                    <div>
                    <label>{language === "English" ? "Week Off" : "आठवडा सुट्टी"}</label>
                    <div>{weekoffCountValue}</div>
                </div>
                </div>


                <div className="attendance-days">
                    <span>{language === "English" ? "Sun" : "रवि"}</span>
                    <span>{language === "English" ? "Mon" : "सोम"}</span>
                    <span>{language === "English" ? "Tue" : "मंगळ"}</span>
                    <span>{language === "English" ? "Wed" : "बुध"}</span>
                    <span>{language === "English" ? "Thu" : "गुरु"}</span>
                    <span>{language === "English" ? "Fri" : "शुक्र"}</span>
                    <span>{language === "English" ? "Sat" : "शनि"}</span>
                </div>

       <div className="attendance-dates">
  {Array.from({ length: 42 }, (_, i) => {
    const dayIndex = i - dates.firstDay;
    if (dayIndex >= 0 && dayIndex < dates.dateArray.length) {
      const date = dates.dateArray[dayIndex];
      const year = attendanceDate.split('-')[0];
      const formattedDate = `${year}-${attendanceDate.split('-')[1]}-${String(date).padStart(2, '0')}`;

      const status = attendanceData[formattedDate]?.status;
      let backgroundColor = '';
      let lateIndicator = '';
      // Check if the date is today
      if (formattedDate === todayString) {
        if (status === 'Full') {
          backgroundColor = 'green';
        } else if (status === 'Half') {
          backgroundColor = '#f1c40f';
        } else if (status === 'Absent' || !status) {
          backgroundColor = '#e10303';
        }
      } else {
        // Check if the date is in the past
        if (new Date(formattedDate) < new Date(todayString)) {
          if (status === 'Full') {
            backgroundColor = 'green';
          } else if (status === 'Half') {
            backgroundColor = '#f1c40f';
          } else if (status === 'Absent' || !status) {
            backgroundColor = '#e10303';
          }
        } else {
          // Check if the date is in the future
          backgroundColor = '#e5e8e8';
        }
      }

      // Check if the date has a late attendance record
      if (attendanceData[formattedDate] && attendanceData[formattedDate].is_late === "true") {
        lateIndicator = 'Late';
      }


      const dayOfWeek = new Date(formattedDate).toLocaleString('en-US', { weekday: 'long' });
      if (weekOffData && weekOffData[dayOfWeek] === 'All undefineds Week Off') {
        backgroundColor = '#909497';
      }

                   return (
                    <div 
  className="date-box" 
  key={i} 
  onClick={() => handleDateClick(date)}
  style={{ backgroundColor , color:'white', display: 'flex', flexDirection: 'column'}}
>
  {date}
  <span style={{color:'black', fontSize: '12px'}}>{lateIndicator}</span>
</div>
                   );
               }
               return <span key={i}></span>;
           })}
       </div>

<style jsx>{`
                    .attendance-container {
                        max-width: 800px;
                        margin: 0 auto;
                        padding: 20px;
                        background-color:#ebf7f7 ;
                        border-radius: 8px;
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                        marginTop:'10px';
                       
                    }

                    .attendance-header {
                        text-align: center;
                        font-size: 2rem;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 10px;
                    }

                    .attendance-section {
                        text-align: center;
                        margin: 20px 0;
                    }

                    .attendance-section label {
                        font-size: 1.2rem;
                        margin-right: 10px;
                    }

                    .attendance-section input[type="month"] {
                        padding: 10px;
                        font-size: 1rem;
                        border-radius: 5px;
                        border: 1px solid #ccc;
                        transition: border 0.3s;
                    }

                    .attendance-section input[type="month"]:focus {
                        border: 1px solid #007BFF;
                        outline: none;
                    }

                    .attendance-labels {
                        display: flex;
                        justify-content: space-around;
                        margin: 20px 0;
                        margin-bottom: 30px;
                    }

                    .attendance-labels div {
                        text-align: center;
                         margin-bottom: 10px;
                    }

                    .attendance-labels label {
                        font-weight: bold;
                    }

                    .vertical-line {
                        border-left: 1px solid #ccc;
                        height: 20px;
                        margin: 0 10px;
                    }

                    .attendance-days {
                        display: flex;
                        justify-content: space-around;
                        margin: 20px 0;
                        font-weight: bold;
                    }

                    .attendance-dates {
                        display: grid;
                        grid-template-columns: repeat(7, 1fr);
                        gap: 10px;
                        margin: 20px 0;
                    }

                    .date-box {
                        text-align: center;
                        border: 1px solid #ccc;
                        padding: 15px;
                        border-radius: 5px;
                        background-color: #f9f9f9;
                        cursor: pointer;
                        transition: background-color 0.3s, transform 0.2s;
                    }

                    .matching-date {
                        background-color: #2ecc71;
                        color: white;
                    }

                    .week-off-date {
        background-color: grey; /* Set the background color for week off dates */
        color: white; /* Text color for week off dates */
    }
     .absent-date {
        background-color: red; /* Set the background color for absent dates */
        color: white; /* Text color for absent dates */
    }

                    .non-matching-date {
                            background-color: #cb1004; /* Set the background color for non-matching dates */
                            color: white; /* Text color for non-matching dates */
                        }
                    .date-box.half-day-date {
                            background-color: #e0a403 !important; 
                            color: white; 
                        }
                    .present-count {
                        text-align: center;
                        margin: 10px 0;
                        font-size: 1.5rem;
                        font-weight: bold;
                        color: #333;
                    }

                    .punch-timings {
                        margin-top: 20px;
                        padding: 10px;
                        border: 1px solid #ccc;
                        border-radius: 5px;
                        background-color: #f9f9f9;
                    }

                    .punch-timings h2 {
                        text-align: center;
                        font-size: 1.5rem;
                        margin-bottom: 10px;
                    }

                    .punch-timings div {
                        margin: 5px 0;
                    }

                    .punch-timings label {
                        font-weight: bold;
                    }
                `}</style>
            </div>
            </div>
    );
}

export default ViewAttendance;
